import { Box, List, ListItem, ListItemText, Typography, useMediaQuery, useTheme } from "@mui/material";

export const TerminosYCondicionesFinbra = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const font_title = isMobileOrTablet ? 20 : 28;
  const font_text = isMobileOrTablet ? 14 : 18;
  return (
    <>
      <Box mx={isMobileOrTablet ? 4 : 25} my={6}>
        <Typography color={theme?.palette?.primary?.main} textAlign={"center"} fontWeight={700} fontSize={font_title}>
          Términos y condiciones aplicables a Personas Físicas, Personas Físicas con Actividad Empresarial y Personas
          Morales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          1. USO Y RESTRICCIONES
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El usuario tendrá derecho de hacer uso de los Servicios y Contenidos comprendidos dentro del Servicio
          Electrónico (en lo sucesivo el <strong>“Portal”</strong>).
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Servicios y Contenidos</strong> significan: (i) todos los servicios y productos que preste al usuario
          a través del
          <strong>
            Portal o de la aplicación, Litore Avances, S.A.P.I. DE C.V., SOFOM, E.N.R. (“Finbra.com”)
          </strong>{" "}
          directamente o en forma conjunta con finbra.com, y (ii) toda la información contenida en el Portal, incluyendo
          cualquier texto, programas, fotografías, imágenes y multimedia son propiedad de Finbra.com tendrá el derecho a
          negar, restringir o condicionar al usuario el acceso al Portal, total o parcialmente, a su entera discreción,
          así como modificar los Servicios y Contenidos del Portal en cualquier momento y sin necesidad de previo aviso.
          El usuario reconoce que los Servicios y Contenidos, así como los bienes y servicios que proporcionan los
          terceros que tienen enlaces al Portal, pueden estar limitados a ciertos usuarios dependiendo de los productos
          y servicios que el usuario tenga contratados previamente, o bien de su ubicación geográfica, por lo que ni
          Finbra.com ni dichos terceros garantizan la disponibilidad de los mismos al usuario.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>“Usuario”</strong> significa: La Persona Física, Persona Física con Actividad Empresarial o bien,
          Persona Moral que actúa mediante su representante legal debidamente facultado de acuerdo a la legislación
          aplicable, misma que por así convenir a sus intereses, solicita el servicio en los términos del presente
          documento.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          2. PROPIEDAD INTELECTUAL
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Los derechos de propiedad intelectual respecto de los Servicios y Contenidos y los signos distintivos y
          dominios del Portal, así como los derechos de uso y explotación de los mismos, incluyendo su divulgación,
          publicación, reproducción, distribución y transformación, son propiedad exclusiva de{" "}
          <strong>Finbra.com, la propiedad intelectual no es compartida</strong>, así como de los distribuidores de
          dicha información por conducto de <strong>Finbra.com</strong>. El usuario no adquiere ningún derecho por el
          simple uso de los Servicios y Contenidos del Portal y en ningún momento dicho uso será considerado como una
          autorización ni licencia para utilizar los Servicios y Contenidos con fines distintos a los que se contemplan
          en los presentes Términos y Condiciones para el Servicio Electrónico.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Todas las marcas, nombres de productos y servicios establecidos en esta página, salvo que se señale lo
          contrario, son propiedad de <strong>Finbra.com</strong> y se encuentran registrados y protegidos por la Ley de
          la Propiedad Industrial, por lo que cualquier uso indebido o reproducción sin autorización del propietario
          constituye un delito.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          3. PROPIEDAD INTELECTUAL DE TERCEROS
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El usuario conoce que los términos que se establecen en el numeral 2 anterior respecto de la titularidad de
          los derechos de los diferentes distribuidores de información que proporcionan diversas entidades a este Portal
          por medio de <strong>Finbra.com</strong>, también son aplicables a los derechos de terceros respecto de los
          servicios y contenidos de las páginas enlazadas al Portal.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          4. USOS PERMITIDOS
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El aprovechamiento de los Servicios y Contenidos del Portal son exclusiva responsabilidad del usuario, quien
          en todo caso deberá servirse de ellos de acuerdo a las funcionalidades permitidas en el propio Portal y a los
          usos autorizados dentro del Contrato del producto y/o servicio que previamente haya contratado, así como de
          los presentes Términos y Condiciones para el Servicios Electrónico, por lo que el usuario se obliga a
          utilizarlos de modo tal que no atenten contra las normas de uso y convivencia en la red mundial de Internet, y
          en cualquiera de las leyes de los Estados Unidos Mexicanos y la legislación vigente en el país en que el
          usuario se encuentre al usarlos, las buenas costumbres, la dignidad de la persona y los derechos de terceros.
          El Portal es para el uso exclusivo del usuario por lo que no podrá comercializar de manera alguna los
          Servicios y Contenidos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          5. PROHIBICIONES
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El usuario no podrá colocar hiperligas del Portal ni al Portal, ni tendrá derecho de colocar o utilizar los
          Servicios y Contenidos del Portal en sitios o páginas propias o de terceros. Asimismo, el usuario no tendrá el
          derecho de limitar o impedir a cualquier otro usuario el uso del Portal
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          6. CALIDAD DE LOS SERVICIOS Y CONTENIDOS
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Ni <strong>Finbra.com</strong>, ni sus proveedores o socios comerciales serán responsables de cualquier daño o
          perjuicio que sufra el usuario a consecuencia de inexactitudes, errores tipográficos, cambios o mejoras que se
          realicen periódicamente a los Servicios y Contenidos. Las recomendaciones y consejos obtenidos a través del
          Portal son de naturaleza general, por lo que no deben tomarse en cuenta en la adopción de decisiones
          personales y empresariales, liberando el usuario a <strong>Finbra.com</strong> de cualquier responsabilidad al
          respecto, para lo cual deberá consultar a un profesional apropiado que pueda asesorarlo de acuerdo con sus
          necesidades específicas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          7. BIENES Y SERVICIOS DE TERCEROS ENLAZADOS
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En caso de que en el Portal se lleguen a incluir enlaces a sitios de terceros, distintos a los de{" "}
          <strong>Finbra.com</strong>, esto no implica que este último apruebe, respalde, recomiende, garantice o sea
          proveedor de los bienes y/o servicios prestados por dichos terceros o del contenido de los sitios, ya que no
          existe ningún tipo de relación laboral, asociación o sociedad, entre <strong>Finbra.com</strong> y los
          terceros. Toda asesoría, consejo, declaración, información y contenido de las páginas de terceros enlazadas a
          este Portal, representan las opiniones y juicios de los terceros, consecuentemente,{" "}
          <strong>Finbra.com</strong> no será responsable de ningún daño o perjuicio que sufra el usuario a consecuencia
          de los mismos, incluyendo, de manera enunciativa mas no limitativa, daños causados por la pérdida de datos o
          programas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          8. SEGURIDAD
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Finbra.com</strong> garantiza la seguridad de la información que se transmite entre el usuario y el
          Portal. La seguridad de la información que se transmite entre el usuario y las páginas de terceros enlazados
          al Portal, será responsabilidad exclusiva de dichos terceros y del usuario. Asimismo, toda aquella información
          que se transmita a través de terceros, como es el caso de la información en línea, será responsabilidad
          exclusiva de los terceros que transmitan la misma al usuario por conducto de <strong>Finbra.com</strong>.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para el uso del Portal y con el objeto de garantizar la seguridad y confidencialidad de las transacciones, es
          necesaria la previa identificación y autenticación del usuario, a través de la solicitud de claves de acceso y
          contraseñas, por lo que todos los datos que recabe <strong>Finbra.com</strong> con este fin, serán tratados
          con absoluta confidencialidad, siendo utilizados para las finalidades para los que han sido solicitados,
          atendiendo a lo dispuesto en los contratos de los productos y servicios previamente celebrados entre el
          usuario y <strong>Finbra.com</strong>, así como por lo dispuesto en la legislación mexicana aplicable.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Finbra.com</strong> no asume responsabilidad alguna sobre: (i) los contenidos y servicios comerciales
          o de otra índole, páginas webs que se puedan vincular electrónicamente directa o indirectamente a través del
          Portal; ni (ii) el intercambio de información electrónica entre usuarios de la red Internet o por causas de
          problemas técnicos que se pudieran producir en equipos informáticos que se utilicen durante la conexión a la
          red Internet.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Factores de autenticación e identificación.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Se entenderá por factores de autenticación, para el ingreso y operación del Servicio Electrónico por Internet
          lo siguiente:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Contraseña:</strong> se referirá a las contraseñas que sean generadas por el usuario.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Contraseña Dinámica o Código de Verificación:</strong> a las contraseñas que contarán con las
          siguientes condiciones:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Serán generadas de manera automática por un tercero autorizado por <strong>Finbra.com</strong> y estas no
          podrán ser conocidas con anticipación a su generación o uso, ya sea por el tercero o personal de{" "}
          <strong>Finbra.com</strong>. Estas serán generadas cuando el usuario la solicite a través del Servicio
          Electrónico por Internet al momento de realizar las operaciones que así lo requieran.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Se enviará al teléfono móvil o al correo que el usuario haya registrado al momento de la contratación y la
          recibirá mediante:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "Mensaje de Texto SMS",
            "Correo electrónico",
            "No podrá ser duplicada o alterada",
            "No podrá ser utilizada en más de una ocasión.",
            "Su vigencia para su uso será de 2 minutos, en caso de usarse después de los 2 minutos se deberá generar un código de verifiación.",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Es de conocimiento del usuario que la Contraseña y Contraseña Dinámica son las llaves para ingresar al
          Servicio Electrónico por Internet, según sea el caso, y sirven de identificación o confirmación de operaciones
          en el servicio. Estas serán utilizadas por finbra.com de la misma manera y para los mismos propósitos y
          alcances que el nombre y la firma autógrafa del usuario, sustituyendo la firma autógrafa del usuario y
          producirán los mismos efectos que las leyes otorgan a los documentos firmados autógrafamente y en consecuencia
          tendrá el mismo valor probatorio.
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "El Identificador de Usuario.",
            "Código de Activación.",
            "Contraseña.",
            "Contraseña Dinámica.",
            "El(os) número(s) de cuenta(s) visualizado(s) dentro del servicio, mostrando únicamente los primeros 2 y los últimos 2 dígitos.",
            "El(os) número(s) de tarjeta(s) de débito dentro del servicio, mostrando únicamente los últimos 4 dígitos..",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El usuario podrá corroborar el correcto acceso al sistema de Finbra.com al tener la visualización en pantalla:
        </Typography>

        <Box
          component="ol"
          sx={{
            counterReset: "item",
            pl: 4,
          }}
        >
          {[
            "Para el caso de Personas Físicas y Personas Físicas con actividad empresarial: su nombre de forma enmascarada visualizando únicamente la primera letra de su(s) nombre(s) y apellido(s).",
            "Para el caso de Personas Morales; la denominación o razón social de la entidad de forma enmascarada visualizando únicamente la primera letra de denominación o razón social.",
          ].map((text, index) => (
            <Box
              component="li"
              key={index}
              sx={{
                display: "list-item",
                counterIncrement: "item",
                "&::marker": {
                  content: 'counter(item, lower-alpha) ")"',
                  color: theme?.palette?.primary?.dark,
                  fontWeight: "bold",
                  fontSize: font_text,
                },
              }}
            >
              <Typography color={theme?.palette?.primary?.dark} fontWeight={400} fontSize={font_text} ml={2}>
                {text}
              </Typography>
            </Box>
          ))}
        </Box>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para garantizar la seguridad en el servicio, <strong>Finbra.com</strong> establece las siguientes condiciones
          de uso, cuyo cumplimiento se encontrarán bajo responsabilidad del usuario:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          9. GEOLOCALIZACIÓN
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para cumplir con la 4ª Bis de las{" "}
          <strong>
            Disposiciones de carácter general a que se refieren los artículos 115 de la Ley de Instituciones de Crédito
            en relación con el 87-D de la Ley General de Organizaciones y Actividades Auxiliares del Crédito y 95-Bis de
            este último ordenamiento, aplicables a las sociedades financieras de objeto múltiple. Finbra.com
          </strong>{" "}
          se encuentra obligada a recabar y utilizar la geolocalización (coordenadas geográficas de latitud y longitud)
          del dispositivo con el que el usuario realice operaciones a través del Portal. De igual forma, la
          geolocalización es utilizada en las actividades de prevención del fraude. Los datos de geolocalización, en su
          caso, podrán ser transferidos a las autoridades competentes conforme a la legislación correspondiente y
          vigente.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El usuario deberá otorgar el consentimiento a <strong>Finbra.com</strong> para acceder a los datos de
          geolocalización de su dispositivo al momento de ingresar al Portal, caso contrario, no podrá realizar
          operaciones o transacciones por este medio, debiendo de utilizar los demás canales que{" "}
          <strong>Finbra.com</strong> pone a su disposición. En este caso, el usuario libera a{" "}
          <strong>Finbra.com</strong> de cualquier responsabilidad en caso de no otorgar el consentimiento indicado en
          este párrafo, obligándose a sacarlo en paz y a salvo en caso de que se presente cualquier controversia por
          dicho motivo.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          10. CONFIDENCIALIDAD
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Finbra.com</strong> se obliga a mantener confidencial la información que reciba del usuario.{" "}
          <strong>Finbra.com</strong> no asume ninguna obligación de mantener confidencial cualquier otra información
          que el usuario le proporcione, ya sea al inscribirse al Portal o en cualquier otro momento posterior,
          incluyendo aquella información que el usuario proporcione a través de boletines, pizarras o plática en línea
          (chats).
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          11. USO DE LA INFORMACIÓN NO CONFIDENCIAL
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Mediante el uso del Portal, el usuario autoriza a <strong>Finbra.com</strong> a utilizar, publicar,
          reproducir, divulgar, comunicar públicamente y transmitir la información no confidencial, en términos de lo
          establecido en el artículo 109 de la Ley Federal de los Derechos de Autor y de la fracción I, del artículo 76
          bis de la Ley Federal de Protección al Consumidor.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          12. CLAVES DE ACCESO Y NÚMEROS CONFIDENCIALES
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En todo momento, el usuario es el responsable único y final de mantener en secreto el número de sus cuentas,
          contraseñas personales, claves de acceso y números confidenciales con los cuales tenga acceso a los Servicios
          y Contenidos del Portal, así como a las páginas de terceros. Para el caso de Persona Moral, esta se obliga a
          limitar el acceso a una sola persona para acceder a la información anteriormente señalada, la cual le serán
          aplicables de igual forma las obligaciones contenidas en el presente documento, toda vez que cualquier
          actuación que se realice será considerada hecha a nombre de la Persona Moral, salvo que se demuestre o
          compruebe lo contrario. El usuario, reconoce el carácter personal, confidencial e intransferible de sus claves
          y contraseñas; en consecuencia, es responsable de su uso conforme a los términos y condiciones aquí
          establecidos, asimismo asume que será de su entera responsabilidad la personalización de su propio Perfil de
          Seguridad, liberando a <strong>Finbra.com</strong> de cualquier responsabilidad en caso del mal uso del Portal
          o de sus claves y contraseñas, obligándose a sacarlo en paz y a salvo en caso de que se presente cualquier
          controversia por dicho motivo. <strong>Finbra.com</strong> se reserva la facultad de cancelar el Servicio
          Electrónico, en caso de que el usuario otorgue un uso distinto al Portal, de acuerdo a lo señalado en estos
          Términos y Condiciones para el Servicio Electrónico, así como en lo dispuesto dentro de los contratos de los
          productos y servicios previamente celebrados por el usuario.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          13. MODIFICACIONES
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Finbra.com</strong> tendrá el derecho de modificar en cualquier momento los Términos y Condiciones
          para el Servicio Electrónico mediante simple publicación de los nuevos términos y condiciones en el Portal, en
          el entendido de que en el caso de que el usuario no esté de acuerdo con dichas modificaciones, deberá
          abstenerse de tener acceso al mismo.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          14. LEYES APLICABLES Y JURISDICCIÓN
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para la interpretación, cumplimiento y ejecución de los presentes Términos y Condiciones para el Servicio
          Electrónico, las partes se someten a la jurisdicción de los tribunales competentes de la Ciudad de México,
          renunciando expresamente a cualquier otro fuero o jurisdicción que pudiera corresponderles en razón de sus
          domicilios presentes o futuros.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          15. TRATAMIENTO DE DATOS PERSONALES
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Finbra.com</strong> es una empresa firmemente comprometida en resguardar la seguridad,
          confidencialidad e integridad de los Datos Personales recolectados de sus usuarios, respetando siempre los
          derechos otorgados a los usuarios de nuestros servicios por las leyes que regulan su actividad. Para conocer
          el tratamiento que <strong>Finbra.com</strong> realiza a los datos personales consultar la sección Aviso de
          Privacidad en la página de <strong>Finbra.com</strong> o en cualquiera de nuestras sucursales.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_text}
          mt={4}
        >
          Fecha última actualización: 11/11/2024
          <br /><br />
        </Typography>
      </Box>
    </>
  );
};
